import { StyleSheet, Text } from '@react-pdf/renderer';

interface IUnitsProps {
  unit?: string;
}

export const Units = ({ unit = '$' }: IUnitsProps) => (
  <Text style={styles.units}>{unit.includes('single') ? unit.split(' ')[0] : unit}</Text>
);

const styles = StyleSheet.create({
  units: {
    minHeight: '7px',
    fontFamily: 'Noto',
    fontWeight: 300,
    fontSize: '7px',
    color: '#77787C',
    marginLeft: 'auto',
    marginBottom: '2px',
  },
});
